import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { omit } from "lodash";
import { useParams } from "react-router-dom";

let myModal = {};

const animatedComponents = makeAnimated();

const initial_value = {
  amount: "",
  selected_payment: {},
  notes: "",
};

export default function ModelReceipt(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [id_value, SerIdValue] = useState(useParams());
  const [payment_types, SetPaymentTypes] = useState([]);
  const [save_data, SetSaveData] = useState(initial_value);
  const [read_only, SetReadOnly] = useState(false);

  useEffect(() => {
    console.log("ModelReceipt On mount :", props);
    let myModal1 = document.getElementById("ModelReceipt");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      console.log("close_data :", close_data);
      SetReadOnly(false);
      SetSaveData({
        amount: "",
        selected_payment: {},
        notes: "",
      });
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("ModelReceipt On mount :", props);
      myModal = new bootstrap.Modal(
        document.getElementById("ModelReceipt"),
        {}
      );
      if (props.type == "add") {
        get_receipt_init();
      }

      if (props.type == "view") {
        SetReadOnly(true);
        SetSaveData((prevValue) => {
          prevValue.amount = props.data.amount;
          prevValue.selected_payment = {
            label: props.data.payment_type,
            value: 0,
          };
          prevValue.notes = props.data.notes;
          return { ...prevValue };
        });
      }
      myModal.show();
    }
  }, [props.open]);

  async function get_receipt_init() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
    };
    let data = await api("/outlet/create_order_receipt_init", pass_data);
    console.log("create_order_receipt_init response :", data);
    if (data.response.hasOwnProperty("total_amount")) {
      data.response.payment_types.map((ele, index) => {
        ele.label = ele.name;
        ele.value = ele.id;
      });
      SetPaymentTypes(data.response.payment_types);
    }
  }

  async function create_receipt() {
    console.log("create receipt :", save_data);
    let pay_type;
    if (save_data.selected_payment.hasOwnProperty("value")) {
      pay_type = save_data.selected_payment.value;
    } else {
      pay_type = "";
    }
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
      post: {
        amount: save_data.amount,
        payment_type: pay_type,
        notes: save_data.notes,
      },
    };
    console.log("pass_data:", pass_data);
    let data = await api("/outlet/create_order_receipt", pass_data);
    console.log("create_order_receipt response :", data.response);
    if (data.response.hasOwnProperty("receipts")) {
      let item = close_data;
      item.action = "save";
      item.value = data.response.receipts[0];
      console.log("Close data : ", item);
      SetCloseData(item);
      SetSaveData(initial_value);
      myModal.hide();
    }
  }

  async function update_custom_price() {
    console.log("update_custom_price ");
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        company_id: id_value.company_id,
      },
      post: {
        services: "",
      },
    };
    let data = await api("/outlet/update_company_service_price", pass_data);
    console.log("update_company_service_price response :", data.response);
    if (data.response.hasOwnProperty("service_price")) {
      let item = close_data;
      item.action = "save";
      item.value = data.response.service_price;
      SetCloseData(item);
      myModal.hide();
    }
  }

  return (
    <div
      className="modal fade"
      id="ModelReceipt"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-title" id="ModalLabel">
              {props.type == "add" ? <h5>Add Receipt</h5> : null}
              {props.type == "view" ? <h5>View Receipt</h5> : null}
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>

          <div className="modal-body">
            <div className="row">
              <h6 className="fs-6">Pending Amount : ₹ {props.pending_amount}</h6>
              <div className="col-12 col-md-6 mt-3">
                <label className="form-label">Amount</label>
                <input
                  type="number"
                  className="form-control"
                  defaultValue={save_data.amount}
                  required
                  disabled={read_only}
                  onChange={(e) => {
                    // console.log("props.pending_amount :", props.pending_amount);
                    // console.log("e.target.value :", e.target.value);
                    // console.log(
                    //   "props.pending check :",
                    //   parseFloat(props.pending_amount) >=
                    //     parseFloat(e.target.value)
                    // );
                    // if (
                    //   parseFloat(props.pending_amount) >=
                    //   parseFloat(e.target.value)
                    // ) {
                    //   SetSaveData((prevValue) => {
                    //     prevValue.amount = e.target.value;
                    //     return { ...prevValue };
                    //   });
                    // }
                    SetSaveData((prevValue) => {
                      prevValue.amount = e.target.value;
                      return { ...prevValue };
                    });
                  }}
                />
              </div>
              <div className="col-12 col-md-6 mb-2 mt-3">
                <label className="form-label">Payment Type</label>
                <Select
                  components={animatedComponents}
                  className="basic-multi-select"
                  classNamePrefix="select Service"
                  placeholder="Select Service"
                  value={save_data.selected_payment}
                  isDisabled={read_only}
                  options={payment_types}
                  onChange={(e) => {
                    console.log("service on change :", e);
                    SetSaveData((prevValue) => {
                      prevValue.selected_payment = e;
                      return { ...prevValue };
                    });
                  }}
                />
              </div>
              <div className="col-12 mt-3">
                <label className="form-label">Note</label>
                <textarea
                  className="form-control"
                  value={save_data.notes}
                  disabled={read_only}
                  onChange={(e) => {
                    SetSaveData((prevValue) => {
                      prevValue.notes = e.target.value;
                      return { ...prevValue };
                    });
                  }}
                />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
            {props.type == "add" ? (
              <button
                type="button"
                className="btn btn-light-outline"
                onClick={() => {
                  create_receipt();
                }}
              >
                Save
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
